import { isValidMedicalRecordValue } from '@/utils/attendanceHelper'

export const getToSign = (
  attendanceSignatureItemCopy,
  medicines,
  medicinesAntimicrobianos
) => {
  const toSign = [0]
  if (attendanceSignatureItemCopy.atestado) {
    toSign.push(1)
  }
  if (attendanceSignatureItemCopy.solicitacaoDeExames) {
    toSign.push(2)
  }
  if (attendanceSignatureItemCopy.solicitacaoDeAPA) {
    toSign.push(3)
  }
  if (attendanceSignatureItemCopy.encaminhamento) {
    toSign.push(4)
  }
  if (
    attendanceSignatureItemCopy.prescricaoMedicamentosa &&
    (medicines.oral.length > 0 || medicines.ocular.length > 0)
  ) {
    toSign.push(5)
  }
  if (
    attendanceSignatureItemCopy.prescricaoMedicamentosa &&
    (medicinesAntimicrobianos.oral.length > 0 ||
      medicinesAntimicrobianos.ocular.length > 0)
  ) {
    toSign.push(9)
  }
  if (attendanceSignatureItemCopy.prescricaoDeOculos) {
    toSign.push(6)
  }
  if (attendanceSignatureItemCopy.declaracaoDeComparecimento) {
    toSign.push(7)
  }
  if (attendanceSignatureItemCopy.declaracaoDeComparecimentoAcompanhante) {
    toSign.push(8)
  }
  if (attendanceSignatureItemCopy.solicitacaoDeCirurgia) {
    toSign.push(10)
  }
  if (attendanceSignatureItemCopy.laudo) {
    toSign.push(11)
  }
  if (attendanceSignatureItemCopy.mapeamentoRetina) {
    toSign.push(12)
  }
  if (attendanceSignatureItemCopy.prescricaoDeLentes) {
    toSign.push(13)
  }
  if (attendanceSignatureItemCopy.posOperatorio) {
    toSign.push(14)
  }
  if (attendanceSignatureItemCopy.pressaoIntraocular) {
    toSign.push(15)
  }
  if (attendanceSignatureItemCopy.gonioscopia) {
    toSign.push(16)
  }
  if (attendanceSignatureItemCopy.biomicroscopia) {
    toSign.push(17)
  }
  if (attendanceSignatureItemCopy.motilidadeOcularExtrinseca) {
    toSign.push(18)
  }
  if (attendanceSignatureItemCopy.curvaTensional) {
    toSign.push(19)
  }
  if (attendanceSignatureItemCopy.campoVisual) {
    toSign.push(20)
  }
  if (attendanceSignatureItemCopy.tomografiaDeCorneaGalilei) {
    toSign.push(21)
  }
  if (
    attendanceSignatureItemCopy.solicitacaoDeTratamento &&
    hasSomeTreatmentActive(
      attendanceSignatureItemCopy.solicitacaoDeTratamento.value
    )
  ) {
    toSign.push(23)
  }
  if (attendanceSignatureItemCopy.topografia) {
    toSign.push(24)
  }
  if (attendanceSignatureItemCopy.octTomografiaDeCoerenciaOptica) {
    toSign.push(25)
  }
  if (attendanceSignatureItemCopy.biometria) {
    toSign.push(26)
  }
  if (attendanceSignatureItemCopy.retinografia) {
    toSign.push(27)
  }
  if (attendanceSignatureItemCopy.paquimetria) {
    toSign.push(28)
  }
  if (attendanceSignatureItemCopy.octTomografiaDeCoerenciaOpticaNervoOptico) {
    toSign.push(29)
  }
  if (attendanceSignatureItemCopy.microscopiaEspecularDeCornea) {
    toSign.push(30)
  }
  if (attendanceSignatureItemCopy.potencialAcuidadeMacular) {
    toSign.push(31)
  }
  if (attendanceSignatureItemCopy.ceratometria) {
    toSign.push(32)
  }
  if (attendanceSignatureItemCopy.bvTriagem) {
    toSign.push(33)
  }
  if (attendanceSignatureItemCopy.bvTesteAcuidadeVisual) {
    toSign.push(34)
  }
  if (attendanceSignatureItemCopy.bvTesteAcuidadeVisualParaPerto) {
    toSign.push(44)
  }
  if (attendanceSignatureItemCopy.bvTesteIshihara) {
    toSign.push(35)
  }
  if (attendanceSignatureItemCopy.oculosExtra) {
    toSign.push(36)
  }
  if (attendanceSignatureItemCopy.pressaoIntraocularCorrigida) {
    toSign.push(37)
  }
  if (attendanceSignatureItemCopy.aberrometria) {
    toSign.push(38)
  }
  if (attendanceSignatureItemCopy.complementoGlaucoma) {
    toSign.push(39)
  }
}

const getValueByKey = (key, checkAttendanceReview) => {
  const entries = Object.entries(checkAttendanceReview)
  for (const [prop, value] of entries) {
    if (prop === key) {
      return value
    }
  }
}

export const getToPrint = (
  attendanceReview,
  medicines,
  medicinesAntimicrobianos
) => {
  const toPrint = []
  const keysToPrint = {
    atestado: 1,
    solicitacaoDeExames: 2,
    solicitacaoDeAPA: 3,
    encaminhamento: 4,
    prescricaoDeOculos: 6,
    declaracaoDeComparecimento: 7,
    declaracaoDeComparecimentoAcompanhante: 8,
    solicitacaoDeCirurgia: 10,
    laudo: 11,
    mapeamentoRetina: 12,
    prescricaoDeLentes: 13,
    posOperatorio: 14,
    prescricaoDeOculosExtra: 36,
    aberrometria: 38,
    complementoGlaucoma: 39
  }

  // Fallback para attendanceReview
  const checkAttendanceReview = attendanceReview
    ? Object.assign({}, attendanceReview)
    : {}

  // Fallback para medicines
  const safeMedicines = medicines || { oral: [], ocular: [] }
  const safeMedicinesOral = Array.isArray(safeMedicines.oral)
    ? safeMedicines.oral
    : []
  const safeMedicinesOcular = Array.isArray(safeMedicines.ocular)
    ? safeMedicines.ocular
    : []

  // Fallback para medicinesAntimicrobianos
  const safeMedicinesAntimicrobianos = medicinesAntimicrobianos || {
    oral: [],
    ocular: []
  }
  const safeMedicinesAntimicrobianosOral = Array.isArray(
    safeMedicinesAntimicrobianos.oral
  )
    ? safeMedicinesAntimicrobianos.oral
    : []
  const safeMedicinesAntimicrobianosOcular = Array.isArray(
    safeMedicinesAntimicrobianos.ocular
  )
    ? safeMedicinesAntimicrobianos.ocular
    : []

  Object.keys(keysToPrint).map(key => {
    if (getValueByKey(key, checkAttendanceReview)) {
      toPrint.push(keysToPrint[key])
    }
  })

  if (checkAttendanceReview.prescricaoMedicamentosa) {
    const hasMedicines =
      safeMedicinesOral.length > 0 || safeMedicinesOcular.length > 0
    const hasAntimicrobialMedicines =
      safeMedicinesAntimicrobianosOral.length > 0 ||
      safeMedicinesAntimicrobianosOcular.length > 0

    if (hasMedicines) {
      toPrint.push(5)
    }

    if (hasAntimicrobialMedicines) {
      toPrint.push(9)
    }

    // Fallback: se marcado mas sem medicamentos, adiciona prescrição padrão
    if (!hasMedicines && !hasAntimicrobialMedicines) {
      toPrint.push(5)
    }
  }

  return toPrint
}

export const newFilledModules = medicalRecords => {
  const filleds = []

  const findFieldByType = type =>
    medicalRecords?.find(record => record.type === type)

  const atestadosMedicos = findFieldByType('atestados-medicos')
  const solicitacaoDeExames = findFieldByType('solicitacao-de-exames')
  const apaAvaliacaoreAnestesica = findFieldByType('apaAvaliacaoreAnestesica')
  const apaAvaliacaoPreAnestesica = findFieldByType(
    'apa-avaliacao-pre-anestesica'
  )
  const encaminhamento = findFieldByType('encaminhamento')
  const prescricaoMedicamentosaV2 = findFieldByType(
    'prescricao-medicamentosa-v2'
  )
  const oculos = findFieldByType('oculos')
  const solicitacaoDeCirurgia = findFieldByType('solicitacao-de-cirurgia')
  const laudoMedico = findFieldByType('laudo-medico')
  const mapeamentoDeRetina = findFieldByType('mapeamento-de-retina')
  const lentesDeContato = findFieldByType('lentes-de-contato')
  const orientacaoPosOperatoria = findFieldByType('orientacao-pos-operatoria')
  const pressaoIntraocular = findFieldByType('pressao-intraocular')
  const gonioscopia = findFieldByType('gonioscopia')
  const biomicroscopia = findFieldByType('biomicroscopia')
  const motilidadeOcularExtrinseca = findFieldByType(
    'motilidade-ocular-extrinseca'
  )
  const curvaTensional = findFieldByType('curva-tensional')
  const campoVisual = findFieldByType('campo-visual')
  const tomografiaDeCorneaGalilei = findFieldByType(
    'tomografia-de-cornea-galilei'
  )
  const solicitacaoDeTratamento = findFieldByType('solicitacao-de-tratamento')
  const topografia = findFieldByType('topografia')
  const octTomografiaDeCoerenciaOptica = findFieldByType(
    'oct-a-tomografia-de-coerencia-optica'
  )
  const biometria = findFieldByType('biometria')
  const retinografia = findFieldByType('retinografia')
  const paquimetria = findFieldByType('paquimetria')
  const octTomografiaDeCoerenciaOpticaNervoOptico = findFieldByType(
    'oct-tomografia-de-coerencia-optica-nervo-optico'
  )
  const microscopiaEspecularDeCornea = findFieldByType(
    'microscopia-especular-de-cornea'
  )
  const potencialAcuidadeMacular = findFieldByType('potencial-acuidade-macular')
  const ceratometria = findFieldByType('ceratometria')
  const bvTriagem = findFieldByType('bv-triagem')
  const bvTesteAcuidadeVisual = findFieldByType('bv-teste-acuidade-visual')
  const bvTesteAcuidadeVisualParaPerto = findFieldByType(
    'bv-teste-acuidade-visual-para-perto'
  )
  const bvTesteIshihara = findFieldByType('bv-teste-ishihara')
  const oculosExtra = findFieldByType('oculosExtra')
  const pressaoIntraocularCorrigida = findFieldByType(
    'pressaoIntraocularCorrigida'
  )
  const aberrometria = findFieldByType('aberrometria')
  const complementoGlaucoma = findFieldByType('complemento-glaucoma')

  // Validations (same as the original)
  if (isValidMedicalRecordValue(atestadosMedicos?.value)) filleds.push(1)
  if (isValidMedicalRecordValue(solicitacaoDeExames?.value)) filleds.push(2)
  if (
    isValidMedicalRecordValue(apaAvaliacaoreAnestesica?.value) ||
    isValidMedicalRecordValue(apaAvaliacaoPreAnestesica?.value)
  )
    filleds.push(3)
  if (isValidMedicalRecordValue(encaminhamento?.value)) filleds.push(4)
  if (
    isValidMedicalRecordValue(prescricaoMedicamentosaV2?.value) &&
    prescricaoMedicamentosaV2?.value?.some(el => !isAntimicrobial(el))
  )
    filleds.push(5)
  if (isValidMedicalRecordValue(oculos?.value)) filleds.push(6)
  if (
    isValidMedicalRecordValue(
      atestadosMedicos?.value?.declaracaoDeComparecimento
    )
  )
    filleds.push(7)
  if (
    isValidMedicalRecordValue(
      atestadosMedicos?.value?.declaracaoDeComparecimentoAcompanhante
    )
  )
    filleds.push(8)
  if (
    isValidMedicalRecordValue(prescricaoMedicamentosaV2?.value) &&
    prescricaoMedicamentosaV2?.value?.some(el => isAntimicrobial(el))
  )
    filleds.push(9)
  if (isValidMedicalRecordValue(solicitacaoDeCirurgia?.value)) filleds.push(10)
  if (isValidMedicalRecordValue(laudoMedico?.value)) filleds.push(11)
  if (isValidMedicalRecordValue(mapeamentoDeRetina?.value)) filleds.push(12)
  if (
    isValidMedicalRecordValue(lentesDeContato?.value) &&
    hasLenteGelatinosa(lentesDeContato.value)
  )
    filleds.push(13)
  if (isValidMedicalRecordValue(orientacaoPosOperatoria?.value))
    filleds.push(14)
  if (isValidMedicalRecordValue(pressaoIntraocular?.value)) filleds.push(15)
  if (isValidMedicalRecordValue(gonioscopia?.value)) filleds.push(16)
  if (isValidMedicalRecordValue(biomicroscopia?.value)) filleds.push(17)
  if (isValidMedicalRecordValue(motilidadeOcularExtrinseca?.value))
    filleds.push(18)
  if (isValidMedicalRecordValue(curvaTensional?.value)) filleds.push(19)
  if (isValidMedicalRecordValue(campoVisual?.value)) filleds.push(20)
  if (isValidMedicalRecordValue(tomografiaDeCorneaGalilei?.value))
    filleds.push(21)
  if (
    isValidMedicalRecordValue(lentesDeContato?.value) &&
    hasLenteRigida(lentesDeContato.value)
  )
    filleds.push(22)
  if (
    isValidMedicalRecordValue(solicitacaoDeTratamento?.value) &&
    hasSomeTreatmentActive(solicitacaoDeTratamento.value)
  )
    filleds.push(23)
  if (isValidMedicalRecordValue(topografia?.value)) filleds.push(24)
  if (isValidMedicalRecordValue(octTomografiaDeCoerenciaOptica?.value))
    filleds.push(25)
  if (isValidMedicalRecordValue(biometria?.value)) filleds.push(26)
  if (isValidMedicalRecordValue(retinografia?.value)) filleds.push(27)
  if (isValidMedicalRecordValue(paquimetria?.value)) filleds.push(28)
  if (
    isValidMedicalRecordValue(octTomografiaDeCoerenciaOpticaNervoOptico?.value)
  )
    filleds.push(29)
  if (isValidMedicalRecordValue(microscopiaEspecularDeCornea?.value))
    filleds.push(30)
  if (isValidMedicalRecordValue(potencialAcuidadeMacular?.value))
    filleds.push(31)
  if (isValidMedicalRecordValue(ceratometria?.value)) filleds.push(32)
  if (isValidMedicalRecordValue(bvTriagem?.value)) filleds.push(33)
  if (isValidMedicalRecordValue(bvTesteAcuidadeVisual?.value)) filleds.push(34)
  if (isValidMedicalRecordValue(bvTesteAcuidadeVisualParaPerto?.value))
    filleds.push(44)
  if (isValidMedicalRecordValue(bvTesteIshihara?.value)) filleds.push(35)
  if (isValidMedicalRecordValue(oculosExtra?.value)) filleds.push(36)
  if (isValidMedicalRecordValue(pressaoIntraocularCorrigida?.value))
    filleds.push(37)
  if (isValidMedicalRecordValue(aberrometria?.value)) filleds.push(38)
  if (isValidMedicalRecordValue(complementoGlaucoma?.value)) filleds.push(39)

  return filleds
}

export const filledModules = form => {
  const filleds = []

  if (!form) {
    throw new Error('Form not found on documentHelper.filledModules')
  }

  if (form.atestadosMedicos.fields.atestado) {
    filleds.push(1)
  }
  if (form.solicitacaoDeExames.value.length) {
    filleds.push(2)
  }
  if (
    form?.apaAvaliacaoreAnestesica?.value?.length ||
    form?.apaAvaliacaoPreAnestesica?.value?.length
  ) {
    filleds.push(3)
  }
  if (form.encaminhamento.value.length) {
    filleds.push(4)
  }
  if (form.prescricaoMedicamentosaV2.value?.some(el => !isAntimicrobial(el))) {
    filleds.push(5)
  }
  if (hasSomeField(form.oculos.fields)) {
    filleds.push(6)
  }
  if (form.atestadosMedicos.fields.declaracaoDeComparecimento) {
    filleds.push(7)
  }
  if (form.atestadosMedicos.fields.declaracaoDeComparecimentoAcompanhante) {
    filleds.push(8)
  }
  if (form.prescricaoMedicamentosaV2.value?.some(el => isAntimicrobial(el))) {
    filleds.push(9)
  }
  if (form.solicitacaoDeCirurgia.value.length) {
    filleds.push(10)
  }
  if (form.laudoMedico.value.length) {
    filleds.push(11)
  }
  if (form.mapeamentoDeRetina.completed) {
    filleds.push(12)
  }
  if (
    hasSomeField(form.lentesDeContato.fields) &&
    hasLenteGelatinosa(form.lentesDeContato.fields)
  ) {
    filleds.push(13)
  }
  if (form.orientacaoPosOperatoria.value.length) {
    filleds.push(14)
  }
  if (form.pressaoIntraocular.completed) {
    if (
      form.pressaoIntraocular.value[0]?.olhoDireito ||
      form.pressaoIntraocular.value[0]?.olhoEsquerdo ||
      form.pressaoIntraocular.value[0]?.tonometria
    ) {
      filleds.push(15)
    }
  }
  if (form.gonioscopia.completed) {
    filleds.push(16)
  }
  if (form.biomicroscopia.completed) {
    filleds.push(17)
  }
  if (form.motilidadeOcularExtrinseca.completed) {
    filleds.push(18)
  }
  if (form.curvaTensional.completed) {
    filleds.push(19)
  }
  if (form.campoVisual.completed) {
    filleds.push(20)
  }
  if (form.tomografiaDeCorneaGalilei.completed) {
    filleds.push(21)
  }
  if (
    hasSomeField(form.lentesDeContato.fields) &&
    hasLenteRigida(form.lentesDeContato.fields)
  ) {
    filleds.push(22)
  }
  if (
    form.solicitacaoDeTratamento.value.length &&
    hasSomeTreatmentActive(form.solicitacaoDeTratamento.value)
  ) {
    filleds.push(23)
  }
  if (form.topografia.completed) {
    filleds.push(24)
  }
  if (form.octTomografiaDeCoerenciaOptica.completed) {
    filleds.push(25)
  }
  if (form.biometria.completed) {
    filleds.push(26)
  }
  if (form.retinografia.completed) {
    filleds.push(27)
  }
  if (form.paquimetria.completed) {
    filleds.push(28)
  }
  if (form.octTomografiaDeCoerenciaOpticaNervoOptico.completed) {
    filleds.push(29)
  }
  if (form.microscopiaEspecularDeCornea.completed) {
    filleds.push(30)
  }
  if (form.potencialAcuidadeMacular.completed) {
    filleds.push(31)
  }
  if (form.ceratometria.completed) {
    filleds.push(32)
  }
  if (form.bvTriagem?.fields?.createdAt) {
    filleds.push(33)
  }
  if (
    form.bvTesteAcuidadeVisual?.fields?.bvOlhoDireito ||
    form.bvTesteAcuidadeVisual?.fields?.bvOlhoEsquerdo
  ) {
    filleds.push(34)
  }
  if (form.bvTesteIshihara?.fields?.hits) {
    filleds.push(35)
  }
  if (form.oculosExtra.completed) {
    filleds.push(36)
  }
  if (form.pressaoIntraocularCorrigida.completed) {
    filleds.push(37)
  }
  if (form.aberrometria.completed) {
    filleds.push(38)
  }
  if (form.complementoGlaucoma.completed) {
    filleds.push(39)
  }
  if (
    form.bvTesteAcuidadeVisualParaPerto.fields?.bvOlhoDireito ||
    form.bvTesteAcuidadeVisualParaPerto.fields?.bvOlhoEsquerdo
  ) {
    filleds.push(44)
  }

  return filleds
}
export const hasLenteGelatinosa = fields => {
  return (
    fields.usarGelatinosa &&
    Object.keys(fields).some(
      key =>
        [
          'olhoDireitoEsferico',
          'olhoDireitoCilindrico',
          'olhoDireitoEixo',
          'olhoDireitoDP',
          'olhoDireitoAdicao',
          'olhoDireitoAV',
          'olhoEsquerdoEsferico',
          'olhoEsquerdoCilindrico',
          'olhoEsquerdoEixo',
          'olhoEsquerdoDP',
          'olhoEsquerdoAdicao',
          'olhoEsquerdoAV',
          'orientacao',
          'usarValoresRefracao',
          'marcaDaLente'
        ].includes(key) && fields[key]
    )
  )
}

export const hasLenteRigida = fields => {
  return (
    fields.usarRigida &&
    Object.keys(fields).some(
      key =>
        [
          'olhoDireitoModelo',
          'olhoDireitoCurva',
          'olhoDireitoDiametro',
          'olhoDireitoGrau',
          'olhoDireitoFabricante',
          'olhoDireitoAVRigida',
          'olhoEsquerdoModelo',
          'olhoEsquerdoCurva',
          'olhoEsquerdoDiametro',
          'olhoEsquerdoGrau',
          'olhoEsquerdoFabricante',
          'olhoEsquerdoAVRigida',
          'orientacaoRigida'
        ].includes(key) && fields[key]
    )
  )
}

// Mesma regra (e mesma PRECEDÊNCIA) do MedicalRecordHelper::getMedicines no
// backend, que é quem monta a receita: o boolean explícito do item vence, o
// cadastro do medicamento só vale quando o item nunca foi decidido.
// `medicines.antimicrobiano` é STRING ('0'/'1') — '0' é truthy em JS, por isso
// nunca ler o campo cru por truthiness.
const readFlag = value => {
  if (value === null || value === undefined || value === false) return false
  const raw = String(value).trim()
  return raw !== '' && raw !== '0'
}

const isAntimicrobial = item => {
  if (typeof item.antimicrobiano === 'boolean') return item.antimicrobiano
  if (item.antimicrobiano !== null && item.antimicrobiano !== undefined) {
    return readFlag(item.antimicrobiano)
  }
  return readFlag(item.medicamento?.antimicrobiano)
}

const hasSomeField = fields => {
  return Object.keys(fields).some(
    key => isNotEmptyArray(fields[key]) || isNotEmptyField(fields[key])
  )
}

const isNotEmptyArray = data => {
  return Array.isArray(data) && data.length
}

const isNotEmptyField = field => {
  return !Array.isArray(field) && field
}

const hasSomeTreatmentActive = treatments => {
  return treatments.some(treatment => treatment.active)
}

export const getDocTypes = () => {
  const typeDoc = [
    'Consulta',
    'Atestado',
    'Solicitação de Exames',
    'Solicitação de APA (Avaliação Pré Anestésica)',
    'Encaminhamento',
    'Prescrição Medicamentosa',
    'Prescrição de Óculos',
    'Declaração de Comparecimento',
    'Declaração de Comparecimento Acompanhante',
    'Prescrição Medicamentosa Antimicrobianos',
    'Solicitação de Cirurgia',
    'Laudo Médico',
    'Mapeamento de retina/fundoscopia',
    'Prescrição de lentes de contato gelatinosa',
    'Orientação ao paciente',
    'Pressão intraocular',
    'Gonioscopia',
    'Biomicroscopia',
    'Motilidade ocular extrínseca',
    'Curva tensional',
    'Campo visual',
    'Tomografia de Córnea (Galilei)',
    'Prescrição de lentes de contato rigida',
    'Solicitação de Tratamento',
    'Topografia',
    'OCT (Tomografia de Coerência Optica) de Mácula',
    'Biometria',
    'Retinografia',
    'Paquimetria',
    'OCT de Nervo Óptico',
    'Microscópia Especular de Córnea',
    'Potencial de Acuidade Macular (PAM)',
    'Ceratometria',
    'Triagem',
    'Teste Acuidade Visual',
    'Teste de Ishihara',
    'Teste Acuidade Visual Para Perto',
    'Prescrição de óculos extra',
    'Pressão intraocular corrigida',
    'Aberrometria',
    'Complemento Glaucoma'
  ]
  return typeDoc
}

export const docsToShowOnEmail = () => {
  const docsToShow = [
    'Solicitação de Exames',
    'Solicitação de Tratamento',
    'Solicitação de APA (Avaliação Pré Anestésica)',
    'Solicitação de Cirurgia',
    'Encaminhamento',
    'Prescrição Medicamentosa',
    'Prescrição de Óculos',
    'Declaração de Comparecimento',
    'Declaração de Comparecimento Acompanhante',
    'Prescrição Medicamentosa Antimicrobianos',
    'Prescrição de lentes de contato gelatinosa',
    'Prescrição de lentes de contato rigida',
    'Orientação ao paciente',
    'Atestado',
    'Laudo Médico',
    'Complemento Glaucoma'
  ]
  return docsToShow
}

export const printableDefault = identifier => {
  const disabledDefault = []
  return !disabledDefault.find(el => el === identifier)
}
